import Vue from "vue";
import buefy from "buefy";

Vue.use(buefy);
